<template>
  <div>
    <Header :university_details="university_details" />
    <!-- ARS -->
    <section class="container py-4">
      <!-- ======== INSTITUTIONAL BENEFITS ====== -->
      <div class="">
        <h2
          class="main-heading-2 primary-color font-weight-bold text-center mt-2 mb-4"
        >
          Institutional Benefits
        </h2>

        <!-- <ul class="list-group list-group-flush">
          <li
            class="list-group-item"
            v-for="item in university_benefits_array"
            :key="item"
          >
            {{ item }}
          </li>
        </ul> -->

        <div v-if="university_details.benefits">
          <div v-html="sanitizeHTML(university_details.benefits)"></div>
        </div>

        <!-- <div class="main-content-1" v-html="university_details.benefits"></div> -->
        <!-- Cards Row -->
        <div
          class="row container mx-auto justify-content-center custom-gap-2 mt-5"
        >
          <!-- Card 1 -->
          <div class="col-12 col-md border rounded py-3">
            <div class="text-center">
              <img
                src="@/assets/imgs/svgs/Icon 04.svg"
                class="img-fluid w-25"
              />
            </div>
            <div class="lead font-weight-bold text-center">
              <p class="text-secondary">Funds Requirement for Visa</p>
              <p class="">
                {{
                  university_details.country_currency_code +
                    " " +
                    university_details.fund_for_visa
                }}
              </p>
            </div>
          </div>
          <!-- Card 2 -->
          <div class="col-12 col-md border rounded py-3">
            <div class="text-center">
              <img
                src="@/assets/imgs/svgs/Icon 01.svg"
                class="img-fluid w-25"
              />
            </div>
            <div class="lead font-weight-bold text-center">
              <p class="text-secondary">Scholarship Policy</p>
              <p class="">
                <span v-html="university_details.scholarship_policy"></span>
              </p>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="col-12 col-md border rounded py-3">
            <div class="text-center">
              <img
                src="@/assets/imgs/svgs/Icon 02.svg"
                class="img-fluid w-25"
              />
            </div>
            <div class="lead font-weight-bold text-center">
              <p class="text-secondary">Part Time</p>
              <p class="">
                <span v-html="university_details.ptw_details"></span>
              </p>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="col-12 col-md border rounded py-3">
            <div class="text-center">
              <img
                src="@/assets/imgs/svgs/Icon 05.svg"
                class="img-fluid w-25"
              />
            </div>
            <div class="lead font-weight-bold text-center">
              <p class="text-secondary">Monthly Living Cost</p>
              <p class="">
                <span v-html="university_details.monthly_living_cost"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <hr />
    </div>

    <!-- ========== LANGUAGES REQUIRED ========== -->
    <!-- <div
      class="main-content-1"
      v-html="university_details.subject_ranking"
    /> -->
    <!-- <ul class="list-group list-group-flush">
      <li
        class="list-group-item"
        v-for="item in university_subject_ranking_array"
        :key="item"
      >
        {{ item }}
      </li>
    </ul> -->
    <section
      v-if="university_details.other_details"
      class="container py-4 row mx-auto"
    >
      <!-- <div class="col col-md-6 mx-auto mb-5 mb-md-0">
        <h2
          class="main-heading-2 primary-color font-weight-bold text-center mb-4"
        >
          Languages Required
        </h2>
        <div
          class="main-content-1 text-center"
          v-html="university_details.languages_required"
        ></div>
      </div> -->

      <div class="col col-md-6 mx-auto" v-if="university_details.other_details">
        <div v-if="university_details.other_details" class="box-shadow">
          <h6 class="sm-title">Other Details</h6>
          <div
            class="main-content-1"
            v-html="university_details.other_details"
          />
        </div>
      </div>
    </section>

    <div class="container-fluid" v-if="university_details.qs_ranking">
      <!-- <hr /> -->
    </div>

    <!-- ============ SUBJECT RANKING ============ -->
    <!-- <section class="container py-4" v-if="university_details.subject_ranking"> -->

    <!-- </section> -->

    <!-- =============== RANKINGS =============== -->
    <section class="container py-4" v-if="university_details.qs_ranking">
      <div class="ranking box-shadow">
        <h2
          class="main-heading-2 primary-color font-weight-bold text-center mb-4"
        >
          Rankings
        </h2>

        <!-- RANKINGS ROW -->
        <div
          class="container mx-auto row justify-content-center align-items-center custom-gap-2"
        >
          <!-- QS RANKING CARD -->
          <div
            v-if="university_details.qs_ranking"
            class="col-12 col-md-3 py-3 px-3 rounded border border-success bg-primary-2-light align-self-stretch"
          >
            <div>
              <h5 class="text-center lead mb-3">
                QS Ranking 2021
              </h5>
              <div class="container-fluid">
                <hr />
              </div>
            </div>
            <div class="d-flex custom-gap-1 justify-content-between px-1">
              <div class="align-self-center">
                <img class="img-fluid" src="@/assets/imgs/world-cup.png" />
              </div>
              <div class="d-flex custom-gap-1">
                <div>
                  <p
                    class="font-weight-bold mb-0"
                    v-html="
                      sanitizeHTML(
                        getRankingArr(university_details.qs_ranking)[0]
                      )
                    "
                  ></p>
                </div>
                <div>
                  <p class="text-right">World</p>
                  <p class="text-right">National</p>
                </div>
              </div>
            </div>
          </div>

          <!-- WORLD TIMES CARD-->
          <div
            v-if="university_details.world_times_ranking"
            class="col-12 col-md-3 py-3 px-3 rounded border border-success bg-primary-2-light align-self-stretch"
          >
            <div>
              <h5 class="text-center lead mb-3">
                World Times Ranking
              </h5>
              <div class="container-fluid">
                <hr />
              </div>
            </div>
            <div class="d-flex custom-gap-1 justify-content-between px-1">
              <div class="align-self-center">
                <img class="img-fluid" src="@/assets/imgs/world-cup.png" />
              </div>
              <div class="d-flex custom-gap-1">
                <div>
                  <p
                    class="font-weight-bold mb-0"
                    v-html="
                      sanitizeHTML(
                        getRankingArr(university_details.world_times_ranking)[0]
                      )
                    "
                  ></p>
                </div>
                <div>
                  <p class="text-right">World</p>
                  <p class="text-right">National</p>
                </div>
              </div>
            </div>
          </div>

          <!-- NATIONAL GUARDIAN RANKING CARD-->
          <div
            v-if="university_details.national_guardian_ranking"
            class="col-12 col-md-3 py-3 px-3 rounded border border-success bg-primary-2-light align-self-stretch"
          >
            <div>
              <h5 class="text-center lead mb-3">
                National Guardian Ranking
              </h5>
              <div class="container-fluid">
                <hr />
              </div>
            </div>
            <div class="d-flex custom-gap-1 justify-content-between px-1">
              <div class="align-self-center">
                <img class="img-fluid" src="@/assets/imgs/world-cup.png" />
              </div>
              <div class="d-flex custom-gap-1">
                <div>
                  <p
                    class="font-weight-bold mb-0"
                    v-html="
                      sanitizeHTML(
                        getRankingArr(
                          university_details.national_guardian_ranking
                        )[0]
                      )
                    "
                  ></p>
                </div>
                <div>
                  <p class="text-right">World</p>
                  <p class="text-right">National</p>
                </div>
              </div>
            </div>
          </div>

          <!-- US WORLD NEWS REPORT CARD -->
          <div
            v-if="university_details.us_world_news_report"
            class="col-12 col-md-3 py-3 px-3 rounded border border-success bg-primary-2-light align-self-stretch"
          >
            <div>
              <h5 class="text-center lead mb-3">
                US World News Report
              </h5>
              <div class="container-fluid">
                <hr />
              </div>
            </div>
            <div class="d-flex custom-gap-1 justify-content-between px-3">
              <div class="align-self-center">
                <img class="img-fluid" src="@/assets/imgs/world-cup.png" />
              </div>
              <div class="d-flex custom-gap-1">
                <div>
                  <p
                    class="font-weight-bold mb-0"
                    v-html="
                      sanitizeHTML(
                        getRankingArr(
                          university_details.us_world_news_report
                        )[0]
                      )
                    "
                  ></p>
                </div>
                <div>
                  <p class="text-right">World</p>
                  <p class="text-right">National</p>
                </div>
              </div>
            </div>
          </div>

          <!-- RANKINGS ROW END -->
        </div>
      </div>
    </section>

    <!-- subject ranking -->
    <hr v-if="university_details.subject_ranking" />
    <!-- <div class="container py-4 ranking box-shadow"> -->
    <h2
      class="main-heading-2 primary-color font-weight-bold text-center mb-4"
      v-if="university_details.subject_ranking"
    >
      Subject Rankings
    </h2>
    <!-- <div class="row container mx-auto justify-space-between">
        <p
          class="col-12 col-md-6 p-2"
          v-for="item in university_subject_ranking_array"
          :key="item"
        >
          {{ item }}
        </p>
      </div> -->
    <!-- </div> -->
    <!-- <hr /> -->

    <div
      class="container-fluid text-center"
      v-if="university_details.subject_ranking"
    >
      <p><span v-html="university_details.subject_ranking"></span></p>
    </div>

    <!-- <div class="container-fluid" v-if="university_details.subject_ranking">
      <hr />
    </div> -->

    <!-- </section> -->

    <!-- ARS END-->

    <section class="university-about">
      <div class="container-fluid">
        <div class="row">
          <!-- <div class="col-lg-12 mb-5">
            <div class="box-shadow">


              <h4 class="main-heading-2 primary-color">
                Institutional Benefits

              </h4>
              <div
                class="main-content-1"
                v-html="university_details.benefits"
              ></div>
              <div id="cards">
                <div class="university-about-cards mt-5">
                  <div class="box-shadow card-col">
                    <div class="circle">
                      <img
                        src="@/assets/imgs/svgs/Icon 04.svg"
                        class="img-fluid"
                      />
                    </div>
                    <div class="pt-5">
                      <p class="light-grey-3">Funds Requirement for Visa</p>
                      <p class="font-weight-bold">
                        {{
                          university_details.country_currency_code +
                          " " +
                          university_details.fund_for_visa
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="box-shadow card-col">
                    <div class="circle">
                      <img
                        src="@/assets/imgs/svgs/Icon 01.svg"
                        class="img-fluid"
                      />
                    </div>
                    <div class="pt-5">
                      <p class="light-grey-3">Scholarship Policy</p>
                      <p class="font-weight-bold">
                        {{ university_details.scholarship_policy }}
                      </p>
                    </div>
                  </div>
                  <div class="box-shadow card-col">
                    <div class="circle">
                      <img
                        src="@/assets/imgs/svgs/Icon 02.svg"
                        class="img-fluid"
                      />
                    </div>
                    <div class="pt-5">
                      <p class="light-grey-3">Part Time</p>
                      <p class="font-weight-bold">
                        <span v-html="university_details.ptw_details"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="col-lg-12 mb-5">
            <div class="box-shadow">
              <h4 class="main-heading-2 primary-color">Languages Required</h4>
              <div
                class="main-content-1"
                v-html="university_details.languages_required"
              ></div>
            </div>
          </div> -->

          <!-- <div class="col-lg-12 mb-5">
            <div class="ranking box-shadow">
              <h4 class="main-heading-2 primary-color">Rankings</h4>
              <div class="ranking__grid">
                <div v-if="university_details.qs_ranking">
                  <div>
                    <h6 class="secondary-title-space">QS Ranking 2021</h6>
                  </div>
                  <div class="ranking-sub__grid">
                    <div class="d-flex align-items-center">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-3">
                        <p class="ranking__num">
                          {{ getRankingArr(university_details.qs_ranking)[0] }}
                        </p>
                        <p class="ranking__sm-text">World</p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-3">
                        <p class="ranking__num">
                          {{ getRankingArr(university_details.qs_ranking)[1] }}
                        </p>
                        <p class="ranking__sm-text">National</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="university_details.world_times_ranking">
                  <div>
                    <h6 class="secondary-title-space">World Times Ranking</h6>
                  </div>
                  <div class="ranking-sub__grid">
                    <div class="d-flex align-items-center">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-3">
                        <p class="ranking__num">
                          {{
                            getRankingArr(
                              university_details.world_times_ranking
                            )[0]
                          }}
                        </p>
                        <p class="ranking__sm-text">World</p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-2">
                        <p class="ranking__num">
                          {{
                            getRankingArr(
                              university_details.world_times_ranking
                            )[0]
                          }}
                        </p>
                        <p class="ranking__sm-text">National</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="university_details.national_guardian_ranking">
                  <h6>National Guardian Ranking</h6>
                  <div class="ranking-sub__grid">
                    <div class="d-flex">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-3">
                        <p class="ranking__num">
                          {{
                            getRankingArr(
                              university_details.national_guardian_ranking
                            )[0]
                          }}
                        </p>
                        <p class="ranking__sm-text">World</p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-3">
                        <p class="ranking__num">
                          {{
                            getRankingArr(
                              university_details.national_guardian_ranking
                            )[0]
                          }}
                        </p>
                        <p class="ranking__sm-text">National</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="university_details.us_world_news_report">
                  <h6 class="secondary-title-space">US World News Report</h6>
                  <div class="ranking-sub__grid">
                    <div class="d-flex">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-2">
                        <p class="ranking__num">
                          <div v-html="university_details.us_world_news_report"></div>
                        </p>
                        <p class="ranking__sm-text">World</p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="ranking__icon">
                        <b-avatar size="48" variant="light-success">
                        </b-avatar>
                      </div>
                      <div class="pl-3">
                        <p class="ranking__num">
                          {{
                            getRankingArr(
                              university_details.us_world_news_report
                            )[0]
                          }}
                        </p>
                        <p class="ranking__sm-text">National</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="university_details.subject_ranking"
              class="subject-rank box-shadow"
            >
              <h4 class="main-heading-2">Subject Ranking</h4>
              <div
                class="main-content-1"
                v-html="university_details.subject_ranking"
              />
            </div>
            <div v-if="university_details.other_details" class="box-shadow">
              <h6 class="sm-title">Other Details</h6>
              <div
                class="main-content-1"
                v-html="university_details.other_details"
              />
            </div>
          </div> -->

          <div class="col-lg-12">
            <div
              v-if="university_details.courses"
              class="box-shadow"
              id="courses"
            >
              <h2
                class="main-heading-2 primary-color font-weight-bold text-center mb-4"
              >
                Courses
              </h2>
              <UniversityCourseDetail :courses="university_details.courses" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Header from "./Navigation";
import CourseProvider from "../Search/helper/CourseProvider.vue";
import UniversityCourseDetail from "../Search/helper/UniversityCourseDetail.vue";

import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody
} from "bootstrap-vue";
import vSelect from "vue-select";
import homeServices from "@/apiServices/homeServices";

export default {
  components: {
    CourseProvider,
    UniversityCourseDetail,
    Header,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    vSelect
  },

  data() {
    return {
      university_id: null,
      university_details: {},
      university_benefits_array: [],
      university_subject_ranking_array: []
    };
  },

  methods: {
    // For gettting rid of blank br tags that vue2-editor introduces on changing university data from the dashboard
    sanitizeHTML(html) {
      return html.replace(/(<br\s*\/?>)|(<p>\s*<br>\s*<\/p>)/gi, "");
    },
    showDropdown(value) {
      this.displayDropdown.splice(value, 1, !this.displayDropdown[value]);
    },
    getRankingArr(str) {
      let new_str = str;
      new_str = new_str.replaceAll('"', "");
      new_str = new_str.replaceAll("<br />", " ");
      new_str = new_str.replace("World : ", "");
      new_str = new_str.replace("National : ", "");
      new_str = new_str.split(" ");
      return new_str;
    },
    async getUniversityDetailsWithCourses() {
      if (this.university_id) {
        const university_id = this.university_id;
        try {
          const response = await homeServices.getUniversityDetailsWithCourses({
            university_id
          });
          if (response.data.status) {
            this.university_details = response.data.data;

            console.log(this.university_details);

            // Benefits Array
            this.university_benefits_array = this.university_details.benefits
              .split("<br />")
              .filter(benefit => benefit.trim() !== "");

            // Subject Ranking Array
            this.university_subject_ranking_array = this.university_details.subject_ranking
              .replaceAll("&amp;", "&")
              .replaceAll(" :", ":")
              .split("<br />")
              .filter(ranking => ranking.trim() !== "");
          } else {
            console.log("Status False ", response.data);
          }
        } catch (error) {
          console.log("Error in getUniversityDetailsWithCourses ", error);
        }
      }
    }
  },
  beforeMount() {
    const { university_id } = this.$route.params;
    if (!isNaN(university_id)) {
      this.university_id = university_id;
      this.getUniversityDetailsWithCourses();
    } else {
      console.log("University id is not a number ", university_id);
    }
  }
};
</script>

<style>
.custom-shadow {
  box-shadow: 5px 10px 20px rgb(40 111 219 / 16%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/University Detail/About.vue